import { Component, Input, OnInit } from '@angular/core';
import { Bericht } from '../../shared/models/Bericht';
import { AngularFireStorage } from '@angular/fire/storage';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-bericht-thumbnail',
  templateUrl: './bericht-thumbnail.component.html',
  styleUrls: ['./bericht-thumbnail.component.scss']
})
export class BerichtThumbnailComponent implements OnInit {
  @Input() bericht: Bericht;
  image: string;
  readonly defaultImage = '';

  constructor(private storage: AngularFireStorage) { }

  ngOnInit() {
    this.getImage();
  }

  getImage() {
    this.storage
      .ref('/bericht_afbeeldingen')
      .child(`/${this.bericht.image}`)
      .getDownloadURL()
      .subscribe(
        (response) => this.image = response,
        (error) => this.image = undefined
      );
  }
}
